<script lang="ts">
	import SocialShareMenu from "@components/data-display/SocialShareMenu.svelte";
	import { useDrawer } from "@components/utils/useDrawer.ts";
	import { onMount } from "svelte";

	export let link: string = "";
	export let objectID: string = "";

	const { open } = useDrawer();

	onMount(() => {
		//use current page if nothing is
		if (!link) {
			link = document.location.href;
		}
	});
</script>

<button
	on:click={() => {
		open(SocialShareMenu, {
			from: "bottom",
			componentProps: {
				index: 0,
				link,
				objectID
			}
		});
	}}
	on:click
>
	<slot />
</button>
